import React from "react";
import LeaveManagement from "../components/LeaveManagement/LeaveManagement";

const LeavePage = () => {
  return (
    <div>
      <h2 style={{ textAlign: "center" }}>Leave Management</h2>
      <LeaveManagement />
    </div>
  );
};

export default LeavePage;
